import * as Yup from 'yup';
import { validaCpf } from 'utils/genericFunctions';

export interface IFormConsultarMutuario {
	cpf: string;
	numContrato: number | string;
}

export const initialValues: IFormConsultarMutuario = {
	cpf: '',
	numContrato: '',
};

export const schema = Yup.object<IFormConsultarMutuario>().shape(
	{
		cpf: Yup.string().test({
			name: 'cpfValidation',
			exclusive: true,
			message: 'CPF digitado inválido.',
			test: value => validaCpf(value),
		}),
		cpfNumContrato: Yup.string()
			.when(['numContrato'], {
				is: numContrato => numContrato === '',
				then: Yup.string().required(
					'Campo obrigatório: Número do contrato para realizar a pesquisa de mutuário',
				),
			})
			.when(['cpf'], {
				is: cpf => cpf !== '' && cpf.length !== 11,
				then: Yup.string().required(
					'Campo CPF: Tamanho mínimo de 11 caracteres.',
				),
			})
			.when(['numContrato'], {
				is: numContrato => numContrato !== '' && numContrato.length !== 7,
				then: Yup.string().required(
					'Campo Número do contrato: Tamanho mínimo de 7 caracteres.',
				),
			}),
	},
	[['cpf', 'numContrato']],
);
